module.exports = __webpack_public_path__ + "static/messenger-source-vehicle-bubbles-d0cf697e398fc1b55292d6ef43272fc3.jpg";